/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */
export enum ExpressLayerType {
  ROUTER = 'router',
  MIDDLEWARE = 'middleware',
  REQUEST_HANDLER = 'request_handler',
}
